const cultureLangCode = window.location.pathname
  .split("-")[0]
  .slice(1, 3)
  .toUpperCase();
const pathname = window.location.pathname.replace(/\/$/, "");
const pageName =
  pathname.split("/").pop() && pathname.split("/").length > 2
    ? pathname.split("/").pop().replace("-", "")
    : "home";
const cultureCountryCode = window.location.pathname
  .split("-")[1]
  .slice(0, 2)
  .toUpperCase();
(function initApptentiveSDK() {
  var ApptentiveSDK = (window.ApptentiveSDK = window.ApptentiveSDK || []);
  if (!ApptentiveSDK.version) {
    if (!ApptentiveSDK.loaded) {
      ApptentiveSDK.loaded = true;
      ApptentiveSDK.methods = [
        "buildDevice",
        "createConversation",
        "createMessage",
        "engage",
        "getSegments",
        "identifyPerson",
        "setOption",
        "setPageName",
        "showInteraction",
        "showMessageCenter",
        "updatePerson",
      ];
      ApptentiveSDK.factory = function factory(t) {
        return function f() {
          for (
            var _len = arguments.length, args = new Array(_len), _key = 0;
            _key < _len;
            _key++
          ) {
            args[_key] = arguments[_key];
          }
          var e = Array.prototype.slice.call(args);
          e.unshift(t);
          ApptentiveSDK.push(e);
          return ApptentiveSDK;
        };
      };
      for (var i = 0; i < ApptentiveSDK.methods.length; i++) {
        var method = ApptentiveSDK.methods[i];
        ApptentiveSDK[method] = ApptentiveSDK.factory(method);
      }
      ApptentiveSDK.LOADER_VERSION = "1.0.0";
    }
  }
})();
const objectData = {
  person: {
    unique_token: User_SessionID, // <= A unique identifier meaningful to you (such as account id)
    custom_data: {
      email: $("#dtmGuestEmail").val() || "n/a",
      guest_id: $("#dtmGuestID").val() || "n/a",
      is_logged_in_user: $("body").hasClass("isLoggedIn"),
      locale_country_code: cultureCountryCode ? cultureCountryCode : "",
      locale_language_code: cultureLangCode ? cultureLangCode : "",
      date: new Date().toLocaleString().split(" ")[0],
      os_version: window.navigator.userAgent,
      rewards_country: cultureCountryCode ? cultureCountryCode : "",
      rewards_member: orderViewModel.Analytics.tierLevel,
    },
  },
  device: {
    custom_data: {
      flash: true,
    },
  },
};
if ($("body").hasClass("isLoggedIn")) {
  objectData.person.email = $("#dtmGuestEmail").val() || "n/a";
}
ApptentiveSDK.createConversation(objectData);
if (localStorage.getItem("Apptentive")) {
  const apptentiveAPIResponse = JSON.parse(localStorage.getItem("Apptentive")).items.person.custom_data;
  const previousCultureCode = (apptentiveAPIResponse.locale_language_code + "-" + apptentiveAPIResponse.locale_country_code).toLowerCase()

  if (previousCultureCode && previousCultureCode != (cultureLangCode + "-" + cultureCountryCode)) {
    ApptentiveSDK.updatePerson(objectData.person);
  }
}

const eventNameList = ApptentiveSurveyEventList || [];
let surveyEventClickCount = 0;
let scrollEvent = [
  { ctaName: "40%scroll", eventName: `40%scroll_${pageName}` },
  { ctaName: "60%scroll", eventName: `60%scroll_${pageName}` },
  { ctaName: "80%scroll", eventName: `80%scroll_${pageName}` },
];
eventNameList.push(...scrollEvent);

const retainSurveyForm = (href, token = null, event=null) => {
  if (href && $("apptentive-survey").length != 0) {
    surveyEventClickCount += 1;
    if (surveyEventClickCount == 1) {
      $("apptentive-survey .apptentive-appbar__action--close , apptentive-survey .apptentive-button--primary").click(
        function () {
          handleRedirectionCheck(href, token, event)
        }
      );
    }
    if (surveyEventClickCount > 1) {
      handleRedirectionCheck(href, token, event)
    }
  } else if (href) {
    handleRedirectionCheck(href, token, event)
  }
}
const formAction = (url, token) => {
  const form = document.createElement('form');
  form.action = url;
  form.method = 'post';
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'CheckoutToken';
  input.value = token;
  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
}

function delayTime(event) {
  if(event && event.target && checkForDancingBubble(event)){
    return 3000;
  }
  return 0;
}

handleRedirectionCheck = (href, token, event=null) => {
    if (token) {
      formAction(href, token);
    }
    else {
      const delayTimer = delayTime(event);
      setTimeout(() => {
        return window.location.href = href
      }, delayTimer);
    }
}

// ENGAGE EVENT Function
function engageApptentiveEvent(
  clickActionName,
  isExistInEventNameList = true,
  href,
  token,
  event
) {
  if (sessionStorage.getItem('parsedModelValues')) {
    sessionStorage.removeItem('parsedModelValues');
    sessionStorage.setItem('redirectionUrl', href);
      return;
  }
  if(event && event.target && checkForDancingBubble(event)) {
    applyDancingBubble(event, 'white')
  }
  if (isExistInEventNameList) {
    let obj = eventNameList.filter((val) => val.ctaName == clickActionName);
    if (obj.length != 0) {
      ApptentiveSDK.engage(obj[0].eventName);
      retainSurveyForm(href, token, event)
    } else {
      const delayTimer = delayTime(event);
      setTimeout(() => {
      if (href) { window.location.href = href; }
      return true;
      }, delayTimer);
    }
  }
  if (!isExistInEventNameList) {
    let dynamicEventName = clickActionName
      .split(" ")
      .join("_")
      .toLowerCase()
      .replace(/[^a-zA-Z0-9\x00-\x7F]/g, "") + "_tapped"
    ApptentiveSDK.engage(dynamicEventName);
    retainSurveyForm(href)
  }
}


const currentURL = window.location.href.toLowerCase();
const lang = subwayScript.navigation.getLanguageCode().toLowerCase();
const validPages = [
  "utm_campaign",
  "howitworks",
  "rewards",
  "catering",
  "rewards-activity",
];
window.triggered40 = false;
window.triggered60 = false;
window.triggered80 = false;
window.triggered100 = false;
if (
  currentURL === window.location.origin + lang ||
  currentURL === window.location.origin + lang + "/" ||
  validPages.some((value) => pathname.includes(value))
) {
  function handleScroll() {
    const scrollPosition = window.scrollY;
    const pageHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = (scrollPosition / pageHeight) * 100;

    if (scrollPosition > 0 && !window.triggered40 && scrollPercentage >= 40) {
      engageApptentiveEvent("40%scroll");
      void 0;
      window.triggered40 = true;
    }

    if (scrollPosition > 0 && !window.triggered60 && scrollPercentage >= 60) {
      engageApptentiveEvent("60%scroll");
      void 0;
      window.triggered60 = true;
    }

    if (scrollPosition > 0 && !window.triggered80 && scrollPercentage >= 80) {
      engageApptentiveEvent("80%scroll");
      void 0;
      window.triggered80 = true;
    }

    if (!window.triggered100 && scrollPercentage >= 99) {
      engageApptentiveEvent("40%scroll");
      engageApptentiveEvent("60%scroll");
      engageApptentiveEvent("80%scroll");
      window.triggered100 = true;
    }
  }
  window.addEventListener("scroll", handleScroll);
}

function checkForDancingBubble(event) {
  let eventClass = ['button start_order no-border', 'cart_bag full no-border'];
  let eventId = ['orderType'];
   if ($("#orderType").is(":visible")) {
     // Check for mobile view bag CTA visibility
     if (
       eventId.includes(event.target.id) ||
       eventId.includes(event.target.parentElement.id)
     ) {
       return true;
     }
   } else {
    const className = event.target.className.includes("contextLoader")
      ? event.target.className.split("contextLoader")[0].trim()
      : event.target.className;
    const parentClassName = event.target.parentElement
      ? event.target.parentElement.className
      : '';
     if (
       eventClass.includes(className) ||
       eventClass.includes(parentClassName)
     ) {
       return true;
     }
   }
   return false; 
}

function applyDancingBubble(event, color, isDisable = false) {
  if (isDisable) {
    disableInteractiveElements();
  }

  let target = event.target.matches('button') || event.target.matches('a') || event.target.matches('div.dancing-bubble-target') ? event.target : event.target.parentElement;

  let height = target.clientHeight;
  let width = target.clientWidth;
  target.disabled = true;
  target.style.width = width + 'px';
  target.style.height = height + 'px';

  target.classList.add("contextLoader");
  localStorage.setItem('innerText', target.innerText);
  localStorage.setItem('targetId', target.id);
  localStorage.setItem('padding', target.style.padding);

  // Create or get hidden aria-live element
  let ariaLiveElement = document.getElementById('ariaLiveElement');
  if (!ariaLiveElement) {
    ariaLiveElement = document.createElement('div');
    ariaLiveElement.id = 'ariaLiveElement';
    ariaLiveElement.setAttribute('aria-live', 'assertive');
    ariaLiveElement.style.position = 'absolute';
    ariaLiveElement.style.width = '1px';
    ariaLiveElement.style.height = '1px';
    ariaLiveElement.style.margin = '-1px';
    ariaLiveElement.style.border = '0';
    ariaLiveElement.style.padding = '0';
    ariaLiveElement.style.overflow = 'hidden';
    document.body.appendChild(ariaLiveElement);
  }

  // Clear any existing interval to avoid multiple intervals
  if (target.ariaIntervalId) {
    clearInterval(target.ariaIntervalId);
  }

  target.ariaIntervalId = setInterval(() => {
    ariaLiveElement.innerText = (ariaLiveElement.innerText === pleaseWaitValue) ? pleaseWaitValue + '.' : pleaseWaitValue;
  }, 2000);

  target.innerHTML = "";
  target.style.padding = '0px';

  let animationFile = "DancingDotsWhite.json";
  if (color === 'white') {
    animationFile = "DancingDotsWhite.json";
  } else if (color === 'green') {
    animationFile = "DancingDotsGreen.json";
  } else if (color === 'gray') {
    animationFile = "DancingDotsGray.json";
  }

  var animation = bodymovin.loadAnimation({
    container: target,
    path: window.location.origin + '/dist/RemoteOrder/jsons/' + animationFile,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "Dancing Dots",
  });

  animation.playSegments([0, 50], true);

  // Store animation instance in the target element for later use
  target.animationInstance = animation;
}


function removeDancingBubble(newText=null) {
  disableInteractiveElements();
  let targetId = localStorage.getItem('targetId');
  if (!targetId) return;

  let target = document.getElementById(targetId);

  if (target) {
    if (target.ariaIntervalId) {
      clearInterval(target.ariaIntervalId);
      delete target.ariaIntervalId;
    }
    
    if (target.animationInstance) {
      target.animationInstance.destroy();  // Stop and remove the animation
    }

    target.disabled = false;
    target.innerHTML = newText || localStorage.getItem('innerText');
    target.style.padding = localStorage.getItem('padding');
    target.style.width = '';
    target.style.height = '';
  }
  target.classList.remove('contextLoader');
  localStorage.removeItem('innerText');
  localStorage.removeItem('targetId');
  localStorage.removeItem('padding');

  // Remove hidden aria live element if it exists
  let ariaLiveElement = document.getElementById('ariaLiveElement');
  if (ariaLiveElement) {
    ariaLiveElement.remove();
  }
}




